import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppConfig } from '@app/config/app.config';
import { ActivationComponent } from './activation/activation.component';
import { BusinessLoginComponent } from './core/auth/component/business-login/business-login.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: AppConfig.routes.certificates.manage,
    pathMatch: 'full'
  },
  {
    path: AppConfig.routes.activation,
    component: ActivationComponent
  },
  {
    path: AppConfig.routes.accounts,
    component: BusinessLoginComponent
  },
  {
    path: AppConfig.routes.business.main,
    loadChildren:()=>import('app/business/business.module').then(x=>x.BusinessModule)
  },

  {
    path: AppConfig.routes.certificates.manage,
    loadChildren:()=>import('app/certificates/certificates.module').then(x=>x.CertificatesModule)
  },
  {
    path: AppConfig.routes.certificates.main,
    loadChildren:()=>import('app/certificates/certificates.module').then(x=>x.CertificatesModule)
  },
  {
    path: AppConfig.routes.profile.main,
    loadChildren:()=>import('app/profile/profile.module').then(x=>x.ProfileModule)
  },
  {
    path: '**',
    redirectTo: AppConfig.routes.certificates.manage
  }
];

@NgModule({
  imports: [RouterModule.forRoot(
    routes
  )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
